module.exports = __webpack_public_path__ + "img/37824-002.e8a8c365.jpg";